import React, { useState, useRef } from 'react';
import axios from 'axios';
export default function ReelsUpload() {
  const [formData, setFormData] = useState({
    title: '',
    price: '',
    location: '',
    virtualTourLink: '',
    videoFile: null,
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === 'video/mp4') {
        setFormData((prev) => ({ ...prev, videoFile: file }));
        setFileName(file.name);
      } else {
        alert('Lütfen sadece .mp4 formatında video yükleyin.');
        e.target.value = null; // Reset input
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      if (file.type === 'video/mp4') {
        setFormData((prev) => ({ ...prev, videoFile: file }));
        setFileName(file.name);
        if(fileInputRef.current) fileInputRef.current.files = e.dataTransfer.files;
      } else {
        alert('Lütfen sadece .mp4 formatında video yükleyin.');
      }
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // Video seçilmiş mi diye ufak bir güvenlik kontrolü
  if (!formData.videoFile) {
    alert('Lütfen yüklemek için bir video dosyası seçin!');
    return;
  }

  try {
    // 1. Sistemde yetkili admin olduğumuzu kanıtlayan kimliğimiz
    const token = localStorage.getItem('token');

    // 2. İçinde "dosya" olan veriler normal yolla gitmez. Özel bir kargo paketi (FormData) hazırlıyoruz.
    const submitData = new FormData();
    submitData.append('title', formData.title);
    submitData.append('price', formData.price);
    submitData.append('location', formData.location);
    submitData.append('virtualTourLink', formData.virtualTourLink);
    submitData.append('video', formData.videoFile); // Asıl ağır dosyamız

    // 3. Veriyi API'ye gönderiyoruz (URL'yi aşağıda konuşacağız)
    // Eğer BACKEND_URL tanımlı değilse hata vermesin diye varsayılan bir yapı ekledim
    const apiUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    
    const response = await axios.post(`${apiUrl}/api/reels`, submitData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data' // DOSYA YÜKLEMENİN SİHRİ BURADA
      }
    });

    console.log("Sunucudan gelen başarılı cevap:", response.data);

    // İşlem başarılıysa formu temizle ve yeşil onay animasyonunu göster
    setIsSubmitted(true);
    setFormData({ title: '', price: '', location: '', virtualTourLink: '', videoFile: null });
    setFileName('');
    if(fileInputRef.current) fileInputRef.current.value = '';

    setTimeout(() => setIsSubmitted(false), 3000);

  } catch (error) {
    console.error('Yükleme hatası:', error);
    alert('Video kaydedilirken bir hata oluştu. Hata detayları için konsola (F12) bakın.');
  }
};

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans text-slate-800">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden">
        
        {/* Header Area */}
        <div className="bg-slate-900 px-8 py-6 text-white">
          <h2 className="text-2xl font-semibold flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-indigo-400">
              <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14v-4z"></path>
              <rect x="3" y="6" width="12" height="12" rx="2" ry="2"></rect>
            </svg>
            Yeni Reel / İlan Ekle
          </h2>
          <p className="text-slate-400 mt-1 text-sm">
            Portföyünüzü genişletin. Video ve detayları aşağıya girin.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          
          {}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Title Input */}
            <div className="md:col-span-2">
              <label htmlFor="title" className="block text-sm font-medium text-slate-700 mb-2">
                İlan Başlığı <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="title"
                name="title"
                required
                placeholder="Örn: Kadıköy Moda'da Deniz Manzaralı 3+1 Lüks Daire"
                value={formData.title}
                onChange={handleInputChange}
                className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-colors outline-none text-slate-700 bg-slate-50 focus:bg-white"
              />
            </div>

            {/* Price Input */}
            <div>
              <label htmlFor="price" className="block text-sm font-medium text-slate-700 mb-2">
                Fiyat <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 font-medium">₺</span>
                <input
                  type="text"
                  id="price"
                  name="price"
                  required
                  placeholder="2.500.000"
                  value={formData.price}
                  onChange={handleInputChange}
                  className="w-full pl-8 pr-4 py-3 rounded-lg border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-colors outline-none text-slate-700 bg-slate-50 focus:bg-white"
                />
              </div>
            </div>

            {/* Location Input */}
            <div>
              <label htmlFor="location" className="block text-sm font-medium text-slate-700 mb-2">
                Konum <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="location"
                name="location"
                required
                placeholder="İlçe, Mahalle (Örn: Kadıköy, Moda)"
                value={formData.location}
                onChange={handleInputChange}
                className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-colors outline-none text-slate-700 bg-slate-50 focus:bg-white"
              />
            </div>

            {/* Virtual Tour Input (Optional) */}
            <div className="md:col-span-2">
              <label htmlFor="virtualTourLink" className="block text-sm font-medium text-slate-700 mb-2">
                3D Sanal Tur Linki <span className="text-slate-400 font-normal text-xs ml-1">(İsteğe Bağlı)</span>
              </label>
              <div className="flex rounded-lg shadow-sm">
                <span className="px-4 inline-flex items-center min-w-fit rounded-l-lg border border-r-0 border-slate-200 bg-slate-100 text-slate-500 text-sm">
                  https://
                </span>
                <input
                  type="url"
                  id="virtualTourLink"
                  name="virtualTourLink"
                  placeholder="my.matterport.com/show/?m=..."
                  value={formData.virtualTourLink}
                  onChange={handleInputChange}
                  className="flex-1 px-4 py-3 rounded-r-lg border border-slate-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-colors outline-none text-slate-700 bg-slate-50 focus:bg-white"
                />
              </div>
            </div>
          </div>

          {}
          <div className="mt-2">
            <label className="block text-sm font-medium text-slate-700 mb-2">
              İlan Videosu (Reel) <span className="text-red-500">*</span>
            </label>
            <div 
              className={`mt-1 flex justify-center px-6 pt-8 pb-8 border-2 border-dashed rounded-xl transition-colors cursor-pointer
                ${fileName ? 'border-indigo-400 bg-indigo-50' : 'border-slate-300 hover:border-indigo-400 bg-slate-50 hover:bg-slate-100'}`}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
            >
              <div className="space-y-2 text-center pointer-events-none">
                {fileName ? (
                  <div className="flex flex-col items-center">
                    <svg className="mx-auto h-12 w-12 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="mt-2 text-sm text-indigo-700 font-medium">Video Seçildi:</p>
                    <p className="text-xs text-slate-500 truncate max-w-xs">{fileName}</p>
                    <p className="text-xs text-indigo-600 mt-2 underline">Değiştirmek için tıklayın</p>
                  </div>
                ) : (
                  <>
                    <svg className="mx-auto h-12 w-12 text-slate-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                      <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <div className="flex text-sm text-slate-600 justify-center">
                      <span className="relative rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                        <span>Video Yükle</span>
                      </span>
                      <p className="pl-1">veya sürükleyip bırakın</p>
                    </div>
                    <p className="text-xs text-slate-500">
                      Sadece MP4 (Maks. 50MB önerilir)
                    </p>
                  </>
                )}
              </div>
              <input 
                id="video-upload" 
                name="video-upload" 
                type="file" 
                className="sr-only" 
                accept="video/mp4"
                ref={fileInputRef}
                onChange={handleFileChange}
                required={!formData.videoFile}
              />
            </div>
          </div>

          {}
          <div className="pt-4 border-t border-slate-100 flex items-center justify-between">
            {isSubmitted ? (
              <span className="text-emerald-600 font-medium text-sm flex items-center gap-2 animate-pulse">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                Bilgiler konsola yazdırıldı!
              </span>
            ) : (
              <span className="text-slate-400 text-xs flex items-center gap-1">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                Zorunlu alanları (*) doldurunuz.
              </span>
            )}

            <button
              type="submit"
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-8 rounded-lg shadow-md shadow-indigo-200 transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 flex items-center gap-2"
            >
              İlanı Kaydet
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}